
import baseConstants from '../../store/base/-constants'
export default {
  name: 'OrganismSidebar',
  computed: {
    isOpen() {
      return this.$store.state[baseConstants.namespace].sidebarOpen
    }
  }
}
